import { DEFAULT_PREFS } from '@adminium/tokens';
/** The 8 COMPILED locales. */
export const LOCALES = [
    'en_US',
    'de_DE',
    'ar_EG',
    'zh_CN',
    'zh_TW',
    'cs_CZ',
    'da_DK',
    'fr_FR',
];
/** Baseline of the resolution order (BRIEF via `@adminium/tokens`). */
export const BASELINE_PREFS = { ...DEFAULT_PREFS };
/** Direction of the COMPILED locales; `null` for anything else. */
export function builtinLocaleDir(locale) {
    if (!LOCALES.includes(locale))
        return null;
    return locale === 'ar_EG' ? 'rtl' : 'ltr';
}
/**
 * Direction for a locale, best-effort and total.
 *
 * A hardcoded `locale === 'ar_EG'` test cannot answer for an admin-created
 * RTL locale, and this package cannot import the runtime registry. So the
 * order is: an injected resolver (the app has the registry) → the compiled
 * table → the cached `dir` axis from the last resolved paint → `ltr`. The
 * cached axis is what keeps a custom RTL locale from flashing on pre-auth
 * screens, where no bootstrap payload exists yet.
 */
export function dirForLocale(locale, opts = {}) {
    return opts.resolve?.(locale) ?? builtinLocaleDir(locale) ?? opts.cached ?? 'ltr';
}
/**
 * BCP-47 form of a locale for the `lang` attribute (`ar_EG` → `ar-EG`).
 * Replaces EVERY underscore: a single replacement leaves `zh-Hant_TW`, which
 * is not a valid tag.
 */
export function langForLocale(locale) {
    return locale.replaceAll('_', '-');
}
//# sourceMappingURL=types.js.map